import { render, staticRenderFns } from "./HouseTypeGroup.vue?vue&type=template&id=d135d50e&"
import script from "./HouseTypeGroup.vue?vue&type=script&lang=js&"
export * from "./HouseTypeGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports